import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import AddUpdateAgendaCard from "../Card/AddUpdateAgendaCard";
import { useSelector } from "react-redux";


function AddUpdateAgendaDialog({ onClose, open }) {
    const currentAgenda = useSelector((state) => state.meeting.currentAgenda);
    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="lg">
            <DialogTitle>{currentAgenda && currentAgenda.length > 0 ? 'Gündem Güncelle' : 'Gündem Ekle'}</DialogTitle>
            <DialogContent dividers>
                <AddUpdateAgendaCard onClose={onClose} />
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

export default AddUpdateAgendaDialog